import NRIBanner from './NRIBanner';
import NRISection from './NRISection';

function NRI() {
  return (
    <div>
      <NRIBanner />
      <NRISection />
    </div>
  );
}

export default NRI;